import script from "./LegoMinifigs.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegoMinifigs.vue?vue&type=script&setup=true&lang=ts"

import "./LegoMinifigs.vue?vue&type=style&index=0&id=145da3cc&lang=css"

export default script